// Belge Dizaynı hesaplama yardımcıları.
// - Aggregate: detay (satır) verisi üzerinden toplam/say/ortalama vb.
// - numberToTurkishWords / moneyToTurkishWords: tutarı yazıyla (TL) gösterir.
// Tümü saf JS — hem tasarım önizlemesi hem yazdırma renderer'ı paylaşır.

export const AGG_FUNCS = [
  { value: 'sum', label: 'Topla (Σ)' },
  { value: 'count', label: 'Say (#)' },
  { value: 'avg', label: 'Ortalama' },
  { value: 'min', label: 'En küçük' },
  { value: 'max', label: 'En büyük' },
];

export const AGG_SHORT = { sum: 'Σ', count: '#', avg: 'Ø', min: '↓', max: '↑' };

// rows: detay satır dizisi (her satır PascalCase alan sözlüğü). field: toplanacak alan anahtarı.
// Dönüş: sayı (veya count için satır sayısı). Veri yoksa null (count için 0).
export function computeAggregate(rows, field, fn = 'sum') {
  if (!Array.isArray(rows) || !rows.length) return fn === 'count' ? 0 : null;
  if (fn === 'count') return rows.length;
  const nums = rows.map((r) => Number(r?.[field])).filter(Number.isFinite);
  if (!nums.length) return null;
  switch (fn) {
    case 'sum': return nums.reduce((a, b) => a + b, 0);
    case 'avg': return nums.reduce((a, b) => a + b, 0) / nums.length;
    case 'min': return Math.min(...nums);
    case 'max': return Math.max(...nums);
    default: return null;
  }
}

const ONES = ['', 'bir', 'iki', 'üç', 'dört', 'beş', 'altı', 'yedi', 'sekiz', 'dokuz'];
const TENS = ['', 'on', 'yirmi', 'otuz', 'kırk', 'elli', 'altmış', 'yetmiş', 'seksen', 'doksan'];
const SCALES = ['', 'bin', 'milyon', 'milyar', 'trilyon'];

function threeDigitsToWords(n) {
  const out = [];
  const h = Math.floor(n / 100);
  const t = Math.floor((n % 100) / 10);
  const o = n % 10;
  if (h) out.push(h === 1 ? 'yüz' : `${ONES[h]} yüz`); // "bir yüz" değil "yüz"
  if (t) out.push(TENS[t]);
  if (o) out.push(ONES[o]);
  return out.join(' ');
}

// 0 .. ~999 trilyon aralığında tam sayıyı Türkçe yazıya çevirir.
export function numberToTurkishWords(num) {
  let n = Math.floor(Math.abs(Number(num) || 0));
  if (n === 0) return 'sıfır';
  const groups = [];
  while (n > 0) { groups.push(n % 1000); n = Math.floor(n / 1000); }
  const parts = [];
  for (let i = groups.length - 1; i >= 0; i -= 1) {
    const g = groups[i];
    if (g === 0) continue;
    let w = threeDigitsToWords(g);
    if (i === 1 && g === 1) w = ''; // "bir bin" değil "bin"
    parts.push(`${w} ${SCALES[i]}`.trim());
  }
  return parts.join(' ').replace(/\s+/g, ' ').trim();
}

// Tutarı yazıyla gösterir: "1.250,50" → "Bin İki Yüz Elli TL Elli Kr".
export function moneyToTurkishWords(value, currency = 'TL', subunit = 'Kr', upper = false) {
  const n = Number(value);
  if (!Number.isFinite(n)) return '';
  const lira = Math.floor(Math.abs(n));
  const kurus = Math.round((Math.abs(n) - lira) * 100);
  let s = `${numberToTurkishWords(lira)} ${currency}`.trim();
  if (kurus > 0) s += ` ${numberToTurkishWords(kurus)} ${subunit}`;
  if (n < 0) s = `eksi ${s}`;
  if (upper) return s.toLocaleUpperCase('tr-TR');
  // Baş harfi büyüt (Türkçe).
  return s.charAt(0).toLocaleUpperCase('tr-TR') + s.slice(1);
}
